import makeCall from "../services/api";

import { galleryImageInterface } from "./editSite";

export default {
    state: {
        searchImages: { data: [] },
        searchObjects: { data: [] }
    },
    mutations: {
        updateSearchResults(state, payload) {
            payload && Object.keys(payload).length > 0 &&
                Object.keys(payload).forEach(k => {
                    if (state[k]) state[k].data = payload[k]
                })
        }
    },
    actions: {
        async globalSearch({ commit }, payload) {
            const { terms } = payload;
            const url = `/search/global-search/${terms}/0/`
            const data = await makeCall({ url }, commit);
            commit('updateSearchResults', data)
        }
    },
    getters: {
        searchData: state => {
            return {
                images: state.searchImages.data.map(i => galleryImageInterface(i)),
                objects: state.searchObjects.data
            }
        }
    }
};
